import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";

import { pathRoute } from "../../Utils/Routes/routes";
import AccountSelector from "../../Utils/Custom/AccountSelector";

import Profile from "../../Pages/Profile";

import * as actions from "../../../store/actions";
import { DarkMode, LightMode } from "@mui/icons-material";

interface Props {
  handleOpenSideBarNavClicked: () => void;
  changeTheme: () => void;
  prefersDarkMode: boolean;
  notificationsNumber?: number;
  hasPermissionSupportOperatorWrite: boolean;
  hasPermissionShippingWrite: boolean;
}

const Header = React.memo((props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const signOutProcess = async () => {
    dispatch(actions.signOutUser());
  };

  const themeZindexDrawer = theme.zIndex.drawer;

  return (
    <div>
      <AppBar
        position="fixed"
        elevation={1}
        color={"default"}
        style={{
          zIndex: themeZindexDrawer + 1,
          backgroundColor: theme.palette.background.default,
          backgroundImage: "none",
          boxShadow: `0px 2px 1px -1px ${theme.palette.background.paper}, 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)`,
        }}
      >
        <Toolbar variant="dense">
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                style={{
                  color: theme.palette.text.primary,
                }}
                onClick={() => {
                  props.handleOpenSideBarNavClicked();
                }}
              >
                <MenuIcon />
              </IconButton>
              <img
                src={
                  theme.palette.mode === "light"
                    ? "/images/anavio-logo-light.svg"
                    : "/images/anavio-logo.svg"
                }
                style={{
                  width: "130px",
                  height: "30px",
                }}
                alt="Anavio logo"
              />
            </Grid>
            <Grid item lg={2}>
              <AccountSelector
                hasPermissionSupportOperatorWrite={props.hasPermissionSupportOperatorWrite}
                hasPermissionShippingWrite={props.hasPermissionShippingWrite}
              />
            </Grid>
            {/* <Grid item className="signOutButton">
              <IconButton
                color="inherit"
                onClick={props.changeTheme}
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.mode === "light" ? "black" : "white",
                })}
              >
                <DarkMode />
              </IconButton>
            </Grid> */}
            <Grid item sx={{ display: "flex" }}>
              <IconButton
                color="inherit"
                onClick={props.changeTheme}
                sx={(theme) => ({
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.mode === "light" ? "black" : "white",
                })}
              >
                {theme.palette.mode === "light" ? <DarkMode /> : <LightMode />}
              </IconButton>
              <IconButton
                sx={{ color: theme.palette.text.primary }}
                color="inherit"
                onClick={() => navigate(pathRoute.Settings.Index)}
              >
                <SettingsIcon />
              </IconButton>
              <Profile /> {/* MenuProfile */}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
});
Header.displayName = "Header";
export default Header;
